/* eslint-disable camelcase */
import { FunctionComponent, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import AddressSearchInput from 'modules/AddressAutocomplete'

import Spacer from 'components/Spacer'

interface IImgSrcProps {
  imgSrc: string
  tabletImgSrc?: string
  desktopImgSrc?: string
}
const HeroImageContainer = styled.div<IImgSrcProps>`
  position: relative;
  background: bottom / cover no-repeat url(${props => props.imgSrc});
  width: 100%;
  height: 540px;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    ${props => props.tabletImgSrc && `background-image: url(${props.tabletImgSrc});`}
  }
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    ${props => props.desktopImgSrc && `background-image: url(${props.desktopImgSrc});`}
  }
`

const HeroImageOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    169.48deg,
    rgba(15, 110, 168, 0.75) 7.83%,
    rgba(18, 153, 236, 0) 52.26%
  );
`

const HeroContentRelativeContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`

const HeroContentContainer = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  margin: 0 auto;
  padding: 0 30px;

  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    justify-content: flex-start;
    align-items: flex-start;
    padding: 72px 48px 0 48px;
    max-width: 1100px;
  }
`

interface IFontSizeProp {
  fontSize?: number
}

const HeroTitle = styled.h1<IFontSizeProp>`
  color: ${props => props.theme.colors.grey16};
  font-weight: 800;
  font-size: 48px;
  text-align: center;
  padding: 0;
  margin: 0;

  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    font-size: 56px;
  }
`

const HeroSubtitle = styled.p`
  color: ${props => props.theme.colors.grey16};
  font-weight: 100;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  padding: 0;
  margin: 0;

  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    font-size: 24px;
    line-height: 32px;
    text-align: left;
  }
`

interface IProps {
  title: string
  subtitle: string
  imgSrc: string
  tabletImgSrc?: string
  desktopImgSrc?: string
}

const AddressHero: FunctionComponent<IProps> = ({
  title,
  subtitle,
  imgSrc,
  tabletImgSrc,
  desktopImgSrc,
}) => {
  const theme = useContext(ThemeContext)

  return (
    <HeroImageContainer
      imgSrc={imgSrc}
      tabletImgSrc={tabletImgSrc}
      desktopImgSrc={desktopImgSrc}
    >
      <HeroImageOverlay />
      <HeroContentRelativeContainer>
        <HeroContentContainer>
          <HeroTitle>{title}</HeroTitle>
          <Spacer
            size={32}
            tabletSize={20}
            responsiveSize={20}
          />
          <HeroSubtitle>{subtitle}</HeroSubtitle>
          <Spacer
            size={50}
            tabletSize={40}
            responsiveSize={30}
          />
          <AddressSearchInput
            buttonBackground={theme.colors.yellow4}
            buttonBackgroundHover={theme.colors.yellow2}
            buttonFontSize={12}
            inputBackground={theme.colors.transparentGrey30Alpha50}
            dropShadow="4px 8px 24px rgba(0, 0, 0, 0.25)"
            width="90vw"
            tabletWidth="720px"
            buttonWidth={200}
          />
        </HeroContentContainer>
      </HeroContentRelativeContainer>
    </HeroImageContainer>
  )
}

export default AddressHero
